import { connect } from "react-redux";

import { fetchEmails, EMAILS_ADD_FILTER, EMAILS_UPDATE_SECTION } from "common/actions/email";

import { TabbedPivotTable } from "../common/tabbedPivotTable";

const fields = [{
    key: "sent_count",
    name: "sent_count",
    valueType: "number"
}, {
    key: "delivered_count",
    name: "delivered_count",
    valueType: "number"
}, {
    key: "open_count",
    name: "open_count",
    valueType: "number"
}, {
    key: "bounce_count",
    name: "bounce_count",
    valueType: "number"
}, {
    key: "click_count",
    name: "click_count",
    valueType: "number"
}];

const pivots = {
    bounce_type: "Bounce type",
    clicked_link: "Clicked link",
    complaint: "Complaint",
    opened: "Opened",
    status: "Status",
    template_ref: "Email type",
    merchant_ref: "Merchant",
    user_email: "User email"
};

const fieldMap = {
    ...pivots,
    sent_count: "Sent count",
    delivered_count: "Delivered count",
    open_count: "Open count",
    bounce_count: "Bounce count",
    click_count: "Click count"
};

const mapStateToProps = (state) => ({
    section: state.emails.section,
    queryDeps: {
        date_range: state.common.date_range,
        qualifiers: state.emails.qualifiers
    }
});

const mapDispatchToProps = {
    ADD_FILTER: EMAILS_ADD_FILTER,
    UPDATE_SECTION: EMAILS_UPDATE_SECTION
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(TabbedPivotTable);

export function EmailPivotRedux(props) {
    return (
        <Connected
            initialStructure={{
                columns: [],
                values: [{
                    name: "sent_count",
                    operation: ["sum"]
                }, {
                    name: "delivered_count",
                    operation: ["sum"]
                }, {
                    name: "open_count",
                    operation: ["sum"]
                }, {
                    name: "bounce_count",
                    operation: ["sum"]
                }, {
                    name: "click_count",
                    operation: ["sum"]
                }],
                filters: []
            }}
            initialSection="merchant_ref"
            initialTabs={[
                {
                    id: "user_email",
                    label: "User email",
                    pivots: ["user_email"]
                },
                {
                    id: "merchant_ref",
                    label: "Merchant",
                    pivots: ["merchant_ref"]
                },
                {
                    id: "template_ref",
                    label: "Email type",
                    pivots: ["template_ref"]
                }, {
                    id: "status",
                    label: "Status",
                    pivots: ["status"]
                }
            ]}
            initialSorting={{
                field: "sent_count",
                dir: "desc"
            }}
            exportName="Email"
            fields={fields}
            fieldMap={fieldMap}
            pivots={pivots}
            queryKey="emails"
            queryFn={fetchEmails}
            {...props}
        />
    );
}
